import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { CssBaseline, ThemeProvider as MuiThemeProvider, useMediaQuery } from '@mui/material';
import { useThemeStore } from '@/features/theme-switcher';
import { getTheme } from '../theme';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const mode = useThemeStore((state) => state.mode);
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });

  const theme = useMemo(() => {
    const resolved = mode === 'system' ? (prefersDark ? 'dark' : 'light') : mode;
    return getTheme(resolved);
  }, [mode, prefersDark]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
